export default __webpack_public_path__ + "static/media/the-singing-one.9ca38360.png";